// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payslip-container {
  max-width: 900px;
  margin: auto;
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: #fefefe;
  border-radius: 10px;
  box-shadow: 0 2px 8px #ccc;
}

.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.section {
  margin-bottom: 20px;
}

.section h3 {
  color: #004080;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

table, th, td {
  border: 1px solid #999;
}

th, td {
  padding: 8px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/payslip/PayslipScreen.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".payslip-container {\n  max-width: 900px;\n  margin: auto;\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  background-color: #fefefe;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px #ccc;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n\n.section {\n  margin-bottom: 20px;\n}\n\n.section h3 {\n  color: #004080;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 5px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\ntable, th, td {\n  border: 1px solid #999;\n}\n\nth, td {\n  padding: 8px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
